import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { GymPlace } from "@/features/training/modules/gym-place/gym-place";
import { PLACE_REPORT_KINDS } from "@/features/training/modules/gym-place/report-kinds";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/gym-places/$placeId")({
  loader: () => ({ crumb: m.gyms_place_title() }),
  validateSearch: z.object({ report: z.enum(PLACE_REPORT_KINDS).optional().catch(undefined) }),
  component: GymPlacePage,
});

function GymPlacePage() {
  const { placeId } = Route.useParams();
  const { report } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <GymPlace
      key={placeId}
      placeId={placeId}
      report={report}
      onReportClosed={report ? () => void navigate({ search: {}, replace: true }) : undefined}
    />
  );
}
